/**
 * Is texting live? (2026-10-10 verification sweep.) While the sms_notifications flag is not 'on', the
 * SMS Terms page and the privacy section say texts aren't available yet and the footer hides its SMS
 * Terms link. Signed-in accounts read the flag live; signed-out visitors (featureFlags/global needs a
 * signed-in reader) ask the server once per page load (/site-status.json, functions/src/seoFiles.ts).
 * Unknown, loading or failed = not live, so the pages never claim texting exists when it doesn't.
 */
import { useEffect, useState } from 'react';
import { useAuthCtx } from '../context/AuthContext';
import { useFeatureFlagsCtx } from '../context/FeatureFlagsContext';
import { smsLiveFromGlobalFlags } from '../lib/sms/consent';

let publicStatus: Promise<boolean> | null = null;

function fetchPublicSmsLive(): Promise<boolean> {
  if (!publicStatus) {
    publicStatus = fetch('/site-status.json', { credentials: 'omit' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j: { smsLive?: unknown } | null) => j?.smsLive === true)
      .catch(() => {
        publicStatus = null; // try again on the next page that asks
        return false;
      });
  }
  return publicStatus;
}

export function useSmsLive(): boolean {
  const { user } = useAuthCtx();
  const { globalFlags, loaded } = useFeatureFlagsCtx();
  const [publicLive, setPublicLive] = useState(false);
  const signedInKnown = Boolean(user) && loaded;

  useEffect(() => {
    if (signedInKnown) return;
    let alive = true;
    void fetchPublicSmsLive().then((v) => {
      if (alive) setPublicLive(v);
    });
    return () => {
      alive = false;
    };
  }, [signedInKnown]);

  return signedInKnown ? smsLiveFromGlobalFlags(globalFlags) : publicLive;
}
